import { Maybe } from '@shared-components/types';

export function resolveEyebrowTextColor({
	isDarkBackground,
	eyebrowStyle,
}: {
	isDarkBackground: boolean;
	eyebrowStyle?: Maybe<string>;
}) {
	if (eyebrowStyle === 'Promo') {
		return 'success.dark';
	}

	return isDarkBackground ? 'text.light' : 'text.secondary';
}
